import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireTcfapi } from "/Users/atanur/Documents/GitHub/es3-QR-SDK-develop/tcfapi/src/tcfapi.js";
var tcfapiExports = requireTcfapi();
export { tcfapiExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(tcfapiExports);